/*
 * Copyright © 2025 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {JaxReportTemplate} from '@dv/shared/backend/model/jax-report-template';
import {ReportType} from '@dv/shared/backend/model/report-type';
import {isNullish, ReportState} from '@dv/shared/code';
import {TranslocoModule} from '@jsverse/transloco';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'dv-report-template-outdated-icon',
    imports: [
        TranslocoModule,
        TooltipModule,
    ],
    templateUrl: './report-template-outdated-icon.component.html',
})
export class ReportTemplateOutdatedIconComponent {

    public reportType = input.required<ReportType>();
    public reportTemplate = input<JaxReportTemplate>();

    public reportTypeTemplateVersion = computed(() => {
        const type = this.reportType();

        return ReportState.fromReportType(type).templateVersion;
    });

    public outdated = computed(() => {
        const typeTemplateVersion = this.reportTypeTemplateVersion();
        const template = this.reportTemplate();
        if (isNullish(typeTemplateVersion) || isNullish(template)) {
            return false;
        }

        return typeTemplateVersion !== template.templateVersion;
    });
}
